<template>
	<!-- <div class="flex relative right-0 z-10 items-center justify-start px-3 py-2 shadow-lg xl:hidden">
		<div
			v-on:click="toggleOpen"
			class="w-10 h-10 cursor-pointer rounded-sm hover:bg-theme-secondary p-2 transition-all hidden xl-max:block"
		>
			<svg
				class="w-5 h-5 text-theme-primary"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 20 20"
				xmlns="http://www.w3.org/2000/svg">
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.2"
					d="M4 6h16M4 12h16M4 18h16" />
			</svg>
		</div>
	</div> -->

	<div
		class="bg-theme-secondary h-full shadow font-Poppins z-30 relative"
		k-data-id="mainSideNav-container">
		<!-- Toggle Button positioned on the right edge -->
		<button
			@click="toggleMenu"
			class="absolute top-1/2 -right-3 transform -translate-y-1/2 w-6 h-6 bg-theme-primary border border-theme-secondary rounded-full flex items-center justify-center hover:bg-theme-secondary transition-colors duration-200 z-50"
			:aria-label="menu ? 'Expand sidebar' : 'Collapse sidebar'"
			k-data-id="mainSideNav-toggleButton">
			<component
				:is="menu ? PhCaretRight : PhCaretLeft"
				class="w-3 h-3 text-theme-primary hover:text-blue-500"
				weight="bold" />
		</button>
		<!-- Main content area -->
		<div
			class="h-full flex flex-col transition-all duration-200"
			:class="menu ? 'w-20' : 'w-64'"
			k-data-id="mainSideNav-content">
			<div
				:class="{ hidden: toggle }"
				class="flex-1 py-4 flex items-start flex-col select-none overflow-y-auto border-r border-theme-secondary"
				k-data-id="mainSideNav-scrollableArea">
				<!-- <svg
				@click="toggleOpen"
				class="xl:hidden w-6 h-6 absolute top-2 right-2 cursor-pointer"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg">
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.2"
					d="M6 18L18 6M6 6l12 12"
				></path>
			</svg> -->

				<div class="flex flex-col grow-0 justify-between">
					<ul
						aria-orientation="vertical"
						class="rounded flex flex-col"
						k-data-id="mainSideNav-navList">
						<router-link
							:aria-label="'View ' + name"
							class="cursor-pointer group px-4 py-1"
							v-for="({ name, href, icon, iconComponent }, index) of tabs"
							:key="index"
							:to="{ path: `${href}` }"
							:k-data-id="`mainSideNav-mainTab-${name.toLowerCase().replace(/\s+/g, '-')}`">
							<div
								:class="[
									'flex items-center group-hover:bg-theme-secondary group-hover:text-blue-500 transition',
									menu ? 'rounded-md p-2 justify-center' : 'rounded-md pl-2 pr-14 py-2 gap-4'
								]">
								<component
									v-if="icon"
									:is="iconComponent"
									weight="light"
									:class="[
										'w-6 h-6 text-theme-primary group-hover:text-blue-500',
										isActive(href) ? 'text-blue-500' : 'text-theme-primary'
									]"
									:k-data-id="`mainSideNav-mainTab-${name.toLowerCase().replace(/\s+/g, '-')}-icon`" />
								<span
									v-if="!menu"
									:class="[
										'text-theme-primary font-light group-hover:text-blue-500',
										isActive(href) ? 'text-blue-500' : 'text-theme-primary'
									]"
									:k-data-id="`mainSideNav-mainTab-${name.toLowerCase().replace(/\s+/g, '-')}-text`">
									{{ name }}
								</span>
							</div>
						</router-link>
						<div
							v-if="subTabs.length > 0"
							:class="['w-full py-2', !menu ? 'px-6' : 'px-4']"
							k-data-id="mainSideNav-subTabsHeader">
							<span
								v-if="!menu"
								class="text-theme-primary text-sm"
								k-data-id="mainSideNav-subTabsHeader-text">
								{{ subTabsText.toUpperCase() }}
							</span>
						</div>
						<div class="flex flex-col" k-data-id="mainSideNav-subTabsList">
							<router-link
								:aria-label="'View ' + (displayName || name)"
								class="cursor-pointer group px-4 py-1"
								v-for="({ name, displayName, icon, iconComponent }, index) of subTabs"
								:key="index"
								:to="{ name }"
								v-slot="{ isActive }"
								:k-data-id="`mainSideNav-subTab-${(displayName || name).toLowerCase().replace(/\s+/g, '-')}`">
								<div
									:class="[
										'flex items-center group-hover:bg-theme-secondary group-hover:text-blue-500 transition',
										menu ? 'rounded-md p-2 justify-center' : 'rounded-md pl-2 pr-18 py-2 gap-4'
									]">
									<component
										v-if="icon"
										:is="iconComponent"
										weight="light"
										:class="[
											'w-6 h-6 group-hover:text-blue-500 transition-colors',
											isActive ? 'text-blue-500' : 'text-theme-primary'
										]"
										:k-data-id="`mainSideNav-subTab-${(displayName || name).toLowerCase().replace(/\s+/g, '-')}-icon`" />
									<span
										v-if="!menu"
										:class="[
											'font-light group-hover:text-blue-500 transition-colors',
											isActive ? 'text-blue-500' : 'text-theme-primary'
										]"
										:k-data-id="`mainSideNav-subTab-${(displayName || name).toLowerCase().replace(/\s+/g, '-')}-text`">
										{{ displayName || name }}
									</span>
								</div>
							</router-link>
						</div>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch, onMounted, markRaw } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { sideNavTabs } from '@constants/Default'
import * as PhosphorIcons from '@phosphor-icons/vue'
import { PhCaretRight, PhCaretLeft } from '@phosphor-icons/vue'

const store = useStore()
const route = useRoute()

const tenant = computed(() => store.getters.getTenant)

const toggle = ref(false)
const menu = ref(false)
const tabs = ref([])
const subTabsText = ref('')
const subTabs = ref([])

const getSideMenuOpen = computed(() => store.getters.getSideMenuOpen)

const getIconComponent = (iconName) => {
	if (!iconName) {
		return null
	}
	return markRaw(PhosphorIcons[iconName])
}

const setupTabs = () => {
	const { name } = route.matched[0]
	const routeTabs = sideNavTabs.find((tab) => tab.name === name)

	if (routeTabs && routeTabs?.tabs?.length > 0) {
		tabs.value = routeTabs.tabs.map((tab) => ({
			...tab,
			iconComponent: getIconComponent(tab.icon)
		}))
	} else {
		tabs.value = []
	}

	if (routeTabs && routeTabs?.subTabs?.length > 0) {
		subTabsText.value = routeTabs.subTabsText
		// Filter out Community subtab if community feature is disabled
		const filteredSubTabs = routeTabs.subTabs.filter((tab) => {
			if (tab.tabIdentifier === 'community-settings') {
				return tenant.value?.features?.community?.active !== false
			}
			return true
		})
		subTabs.value = filteredSubTabs.map((tab) => ({
			...tab,
			iconComponent: getIconComponent(tab.icon)
		}))
	} else {
		subTabs.value = []
	}
}

const isActive = (link) => {
	const { path } = route
	// Handle exact match first
	if (link === path) return true
	// Handle nested routes - if current path starts with the link and the link ends with a slash or the next character is a slash
	if (path.startsWith(link) && (link.endsWith('/') || path.charAt(link.length) === '/')) return true
	return false
}

const toggleMenu = () => {
	menu.value = !menu.value
	// Don't modify the store state, just toggle local menu state
}

// Initialize menu state based on store state
watch(
	getSideMenuOpen,
	(val, oldVal) => {
		if (val !== oldVal && oldVal !== undefined) {
			// Only sync if the store value actually changed
			// When collapsed, menu should be true (show icons only)
			menu.value = !val
		}
	},
	{ immediate: true }
)

watch(
	() => route.path,
	() => {
		setupTabs()
	}
)

watch(
	() => tenant.value?.features,
	() => {
		setupTabs()
	},
	{ deep: true }
)

onMounted(() => {
	setupTabs()
	// Initialize menu state - if sideMenuOpen is false, show icons only
	menu.value = !getSideMenuOpen.value
})
</script>

<style scoped>
.sidebar {
	display: table-cell;
	vertical-align: top;
}
</style>
